import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { TransformedStudentDetail } from '../../../types/userType';
import pallet from '../../../layouts/pallet';
import {
  StudentDetailsContainer,
  ChipsContainer,
  StyledChip,
  StudentInfoRow,
  StudentInfoItem
} from '../styled/studentDetails';
import { PaperWrapper } from '../../common/styled';

interface StudentDetailsProps {
  studentData: TransformedStudentDetail;
}

const StudentDescriptionTile: React.FC<StudentDetailsProps> = ({
  studentData
}) => {
  return (
    <PaperWrapper mb='16px'>
      <StudentDetailsContainer>
        <Box>
          <Avatar
            src={studentData.studentDetails.profile}
            alt={studentData.studentDetails.name}
            sx={{ width: 120, height: 120 }}
          />
        </Box>
        <Box flexGrow={1}>
          <ChipsContainer>
            <StyledChip
              label={`${
                studentData.studentDetails?.status === 'ACTIVE'
                  ? 'Active'
                  : 'InActive'
              }`}
              className={
                studentData.studentDetails?.status === 'ACTIVE'
                  ? 'success'
                  : 'danger'
              }
            />
            <StyledChip
              label={`${
                studentData.studentDetails.isNewAdmission
                  ? 'New Admission'
                  : 'Existing'
              }`}
              className={'success'}
            />
          </ChipsContainer>
          <StudentInfoRow>
            <StudentInfoItem>
              <Typography variant='body2' color='text.secondary'>
                Student name:
              </Typography>
              <Typography variant='body1' fontWeight='bold'>
                {studentData.studentDetails.name}
              </Typography>
            </StudentInfoItem>
            <StudentInfoItem>
              <Typography variant='body2' color='text.secondary'>
                Student's email:
              </Typography>
              <Typography
                variant='body1'
                fontWeight='bold'
                sx={{ color: pallet.primary }}
              >
                {studentData.studentDetails.email}
              </Typography>
            </StudentInfoItem>
            <StudentInfoItem>
              <Typography variant='body2' color='text.secondary'>
                Grade & Division:
              </Typography>
              <Typography variant='body1' fontWeight='bold'>
                {studentData.studentDetails.currentClass}
              </Typography>
            </StudentInfoItem>
            <StudentInfoItem>
              <Typography variant='body2' color='text.secondary'>
                Enrollment No:
              </Typography>
              <Typography variant='body1' fontWeight='bold'>
                {studentData.studentDetails.enrollmentNo}
              </Typography>
            </StudentInfoItem>
            <StudentInfoItem>
              <Typography variant='body2' color='text.secondary'>
                Academic Year:
              </Typography>
              <Typography variant='body1' fontWeight='bold'>
                {studentData.studentDetails.academicYear}
              </Typography>
            </StudentInfoItem>
            <StudentInfoItem>
              <Typography variant='body2' color='text.secondary'>
                Father's name:
              </Typography>
              <Typography variant='body1' fontWeight='bold'>
                {studentData.fatherDetails.name}
              </Typography>
            </StudentInfoItem>
            <StudentInfoItem>
              <Typography variant='body2' color='text.secondary'>
                Mother's name:
              </Typography>
              <Typography variant='body1' fontWeight='bold'>
                {studentData.motherDetails.name}
              </Typography>
            </StudentInfoItem>
            <StudentInfoItem>
              <Typography variant='body2' color='text.secondary'>
                Date of Joining
              </Typography>
              <Typography variant='body1' fontWeight='bold'>
                {studentData.studentDetails.dateOfJoining
                  ? new Date(
                      studentData.studentDetails.dateOfJoining
                    ).toLocaleDateString()
                  : '-'}
              </Typography>
            </StudentInfoItem>
          </StudentInfoRow>
        </Box>
      </StudentDetailsContainer>
    </PaperWrapper>
  );
};

export default StudentDescriptionTile;
